import '../styles/stepThree.css'
import checkbox from '../assets/images/icon-checkmark.svg'
import { useContext, useEffect, useRef, useState } from 'react';
import AppContext from '../context/formContext';

const StepThree = () => {   
    
    const { setForm } = useContext(AppContext)
    

    const optionOne = useRef()
    const optionTwo = useRef()
    const optionThree = useRef()


    const [optOne, setOptOne] = useState(false);
    const [optTwo, setOptTwo] = useState(false);
    const [optThree, setOptThree] = useState(false);
    const [mode, setMode] = useState('Monthly');
    
    useEffect(() => {
        const plan = JSON.parse(localStorage.getItem('plan'));
        setMode(plan.range);
    }, [])

    const handleCheckbox = () => {
        const values = [];
        let addOnsTotal = 0;
          const checkboxs = [optionOne.current, optionTwo.current, optionThree.current];
          checkboxs.forEach((checkbox) => {
              if (checkbox.checked) {
                  values.push({ name: checkbox.name, value: checkbox.value })
                  addOnsTotal += +(checkbox.value);
              }
          })
        
        localStorage.setItem('addOns', JSON.stringify(values))
        localStorage.setItem('addOnsTotal',addOnsTotal)
    }
    
    const handleSubmit = (e) => {
        e.preventDefault();
        handleCheckbox()
        setForm(4)

    }

  

    return ( 
        <div className="stepThreeCard">
            <section>
                <h1>Pick add-ons</h1>
                <p>Add-ons help enhance your gaming experience.</p>
            </section>
            <form onSubmit={(e)=>handleSubmit(e)}>
                <label htmlFor="onlineSrv" className={`addOns ${optOne ? 'selectedOpt' : ''}`}>
                    <div className={`checkbox ${optOne ? 'selected' : ''}`}>
                        <img src={checkbox} alt="" />
                    </div>
                    <input ref={optionOne} type="checkbox" id="onlineSrv" name="Online Service" data-role="checkbox"
                        value={mode === 'Monthly' ? 1 : 10}
                    onChange={(e) => {
                        optOne ? setOptOne(false) : setOptOne(true)
                        
                    }}/>
                    <div className="details">
                        <h3 className="name">Online service</h3>
                        <p className="smallDis">Access to multiplayer games</p>
                    </div>
                    <aside>{mode === 'Monthly' ? '+1/mo' : '+10/yr'}</aside>
                </label>

                <label htmlFor="largeStr" className={`addOns ${optTwo ? 'selectedOpt' : ''}`}>
                    <div className={`checkbox ${optTwo ? 'selected' : ''}`}>
                        <img src={checkbox} alt="" />
                    </div>
                    <input type="checkbox" id="largeStr" name='Large Storage' data-role="checkbox" ref={optionTwo}
                        value={mode === 'Monthly' ? 2 : 20}
                        onChange={(e) => {
                            optTwo ? setOptTwo(false) : setOptTwo(true)
                            
                    }}/>
                    <div className="details">
                        <h3 className="name">Larger storage</h3>
                        <p className="smallDis">Extra 1TB of cloud save</p>
                    </div>
                    <aside>{mode === 'Monthly' ? '+2/mo' : '+20/yr'}</aside>
                </label>

                <label htmlFor="ctz" className={`addOns ${optThree ? 'selectedOpt' : ''}`}>
                    <div className={`checkbox ${optThree ? 'selected' : ''}`}>
                        <img src={checkbox} alt="" />
                    </div>
                    <input type="checkbox" id="ctz" name='Customizable Profile' data-role="checkbox" ref={optionThree}
                        value={mode === 'Monthly' ? 2 : 20}
                        onChange={(e) => {
                            optThree ? setOptThree(false) : setOptThree(true)
                            
                    }}/>
                    <div className="details">
                        <h3 className="name">Customizable Profile</h3>
                        <p className="smallDis">Custom theme on your profile</p>
                    </div>
                    <aside>{mode === 'Monthly' ? '+2/mo' : '+20/yr'}</aside>
                </label>
                <button className='goBack' onClick={()=>setForm(2)}>Go Back</button>
                 <input className="nextBtn" type="submit" value="Next Step"></input>
            </form>
        </div>
     );
}
 
export default StepThree;